import React, { useEffect, useState } from "react";
import MerchMapSVG from "./MerchMapSVG";

const API_URL =
  process.env.REACT_APP_BACKEND_URL || "https://topnationapp-1-api.onrender.com";

const PRODUCTS = [
  { id: "t-shirt", label: "TSHIRT", price: 4999, image: "/tshirt-real.png" },
  { id: "hoodie", label: "HOODIE", price: 9999, image: "/hoodie-real.png" },
];

const SIZES = ["S", "M", "L", "XL", "XXL"];
const COUNTRY_NAMES = {
  SK: "Slovakia",
  CZ: "Czech Republic",
  US: "United States",
  DE: "Germany",
  FR: "France",
};

export default function MerchModal({ isOpen, onClose, countryCode, country }) {
  const [selectedLeft, setSelectedLeft] = useState("t-shirt");
  const [sizeLeft, setSizeLeft] = useState("L");

  const [selectedRight, setSelectedRight] = useState("t-shirt");
  const [sizeRight, setSizeRight] = useState("L");

  const [termsAcceptedLeft, setTermsAcceptedLeft] = useState(false);
  const [termsAcceptedRight, setTermsAcceptedRight] = useState(false);

  const [showTerms, setShowTerms] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [showCryptoForm, setShowCryptoForm] = useState(false);
  const [cryptoSide, setCryptoSide] = useState(null);

  // 🔥 DOPLNENÉ
  const [showCardForm, setShowCardForm] = useState(false);
  const [cardSide, setCardSide] = useState(null);

  const [shipping, setShipping] = useState({
    name: "",
    email: "",
    address: "",
  });

  const user = JSON.parse(localStorage.getItem("user"));
  const [ownedCountries, setOwnedCountries] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    fetch(`${API_URL}/api/user/countries`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        const myCountries = Array.isArray(data?.countries)
          ? data.countries.map((c) => c.country_code).filter(Boolean)
          : [];
        setOwnedCountries(myCountries);
      })
      .catch((err) => console.error(err));
  }, [isOpen]);

  const isTopBidderForThisCountry =
    country &&
    country.country_code === countryCode &&
    country.top_bidders &&
    country.top_bidders.length > 0 &&
    String(country.top_bidders[0].user_id) === String(user?.id);

  if (!isOpen) return null;

  const currentLeft = PRODUCTS.find((p) => p.id === selectedLeft);
  const currentRight = PRODUCTS.find((p) => p.id === selectedRight);

  const pay = async (method, current, size, side) => {
    if (
      (side === "left" && !termsAcceptedLeft) ||
      (side === "right" && !termsAcceptedRight)
    ) {
      alert("You must accept Terms & Conditions.");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) return alert("Login first");

    const endpoint =
      method === "crypto"
        ? `${API_URL}/api/merch/crypto-checkout`
        : `${API_URL}/api/merch/checkout`;

    const finalPrice =
      side === "left"
        ? current.id === "t-shirt"
          ? 999
          : 1999
        : current.id === "t-shirt"
        ? 4999
        : 9999;

    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        product: current.id,
        size,
        price: finalPrice,
        amount: finalPrice,
        country: countryCode,
        color: "black",
        quantity: 1,
        origin_url: window.location.origin,
        name: shipping.name,
        email: shipping.email,
        address: shipping.address,
      }),
    });

    const data = await res.json();

    if (method === "crypto" && data.invoice_url) {
      window.open(data.invoice_url, "_blank");
    } else if (data.checkout_url) {
      window.location.href = data.checkout_url;
    }
  };

  return (
    <>
     <div onClick={onClose} style={overlay}>
  <div onClick={(e) => e.stopPropagation()} style={{
    display: "flex",
    gap: 10,
    flexDirection: "row",
    flexWrap: "nowrap",

 transform:
  window.innerWidth > 1200
    ? "scale(1.2)"
    : window.innerWidth > 900
    ? "scale(1.05)"
    : window.innerWidth > 600
    ? "scale(0.9)"
    : "scale(0.75)",
transformOrigin: "center center",
  }}>

          {/* LEFT */}
          <div style={modalBox}>
            <button onClick={onClose} style={closeBtn}>&times;</button>

            <h2 style={heading}>
              CLASSIC EDITION
            </h2>

            <div style={productRow}>
              {PRODUCTS.map((p) => (
                <div
                  key={p.id}
                  onClick={() => setSelectedLeft(p.id)}
                  style={{
                    ...productCard,
                    border: selectedLeft === p.id ? "2px solid #FFD700" : "2px solid #111"
                  }}
                >
                  <div style={imageWrap}>
                    <img src={p.image} alt="" style={productImg} />
                    <div style={p.id === "t-shirt" ? mapOverlayTshirt : mapOverlay}>
                      <MerchMapSVG
                        countryCode={countryCode}
                        ownedCountries={isTopBidderForThisCountry ? ownedCountries : []}
                      />
                    </div>
                  </div>

                  <div style={productLabel}>{p.label}</div>
                  <div style={productPrice}>€{p.id === "t-shirt" ? 999 : 1999}</div>
                </div>
              ))}
            </div>

            {/* SIZE LEFT */}
            <div style={sizeRow}>
              {SIZES.map((s) => (
                <button
                  key={s}
                  onClick={() => setSizeLeft(s)}
                  style={{
                    ...sizeBtn,
                    border: sizeLeft === s ? "2px solid #FFD700" : "1px solid #333",
                    color: sizeLeft === s ? "#FFD700" : "#aaa"
                  }}
                >
                  {s}
                </button>
              ))}
            </div>

            <div style={termsRow}>
              <label style={{ display: "flex", justifyContent: "center", gap: 6 }}>
                <input
                  type="checkbox"
                  checked={termsAcceptedLeft}
                  onChange={(e) => setTermsAcceptedLeft(e.target.checked)}
                />
                <span onClick={() => setShowTerms(true)} style={{ color: "#FFD700", cursor: "pointer", textDecoration: "underline" }}>
                  Terms & Conditions
                </span>
              </label>
            </div>

            <div style={btnRow}>
              <button onClick={() => { setCardSide("left"); setShowCardForm(true); }} style={cardBtn}>
                💳 Card
              </button>

              <button onClick={() => { setCryptoSide("left"); setShowCryptoForm(true); }} style={cryptoBtn}>
                🪙 Crypto
              </button>
            </div>
          </div>

          {/* RIGHT */}
          <div style={{ ...modalBox, boxShadow: "0 0 60px rgba(255,215,0,0.6)" }}>
            <button onClick={onClose} style={closeBtn}>&times;</button>

            <h2 style={heading}>LIMITED EDITION</h2>

            <div style={productRow}>
              {PRODUCTS.map((p) => (
                <div
                  key={p.id}
                  onClick={() => setSelectedRight(p.id)}
                  style={{
                    ...productCard,
                    border: selectedRight === p.id ? "2px solid #FFD700" : "2px solid #111"
                  }}
                >
                  <div style={imageWrap}>
                    <img src={p.image} alt="" style={productImg} />
                    <div style={p.id === "t-shirt" ? mapOverlayTshirtRight : mapOverlay}>
                      <MerchMapSVG countryCode={countryCode} ownedCountries={ownedCountries} />
                    </div>
                  </div>

                  <div style={productLabel}>{p.label}</div>
                  <div style={productPrice}>€{p.price}</div>
                </div>
              ))}
            </div>

            {/* SIZE RIGHT */}
            <div style={sizeRow}>
              {SIZES.map((s) => (
                <button
                  key={s}
                  onClick={() => setSizeRight(s)}
                  style={{
                    ...sizeBtn,
                    border: sizeRight === s ? "2px solid #FFD700" : "1px solid #333",
                    color: sizeRight === s ? "#FFD700" : "#aaa"
                  }}
                >
                  {s}
                </button>
              ))}
            </div>

            <div style={termsRow}>
              <label style={{ display: "flex", justifyContent: "center", gap: 6 }}>
                <input
                  type="checkbox"
                  checked={termsAcceptedRight}
                  onChange={(e) => setTermsAcceptedRight(e.target.checked)}
                />
                <span onClick={() => setShowTerms(true)} style={{ color: "#FFD700", cursor: "pointer", textDecoration: "underline" }}>
                  Terms & Conditions
                </span>
              </label>
            </div>

            <div style={btnRow}>
              <button onClick={() => { setCardSide("right"); setShowCardForm(true); }} style={cardBtn}>
                💳 Card
              </button>

              <button onClick={() => { setCryptoSide("right"); setShowCryptoForm(true); }} style={cryptoBtn}>
                🪙 Crypto
              </button>
            </div>
          </div>

        </div>
      </div>

      {/* STRIPE POPUP */}
      {showCardForm && (
        <div style={overlay}>
          <div style={{ ...modalBox, maxWidth: 400 }}>
            <button onClick={() => setShowCardForm(false)} style={closeBtn}>&times;</button>

            <input placeholder="Name" value={shipping.name} onChange={(e)=>setShipping({...shipping,name:e.target.value})} style={inputStyle}/>
            <input placeholder="Email" value={shipping.email} onChange={(e)=>setShipping({...shipping,email:e.target.value})} style={inputStyle}/>
            <input placeholder="Address" value={shipping.address} onChange={(e)=>setShipping({...shipping,address:e.target.value})} style={inputStyle}/>
            <div style={{
  ...inputStyle,
  display: "flex",
  alignItems: "center",
  color: "#FFD700",
  fontWeight: "bold"
}}>
  {cardSide==="left"?sizeLeft:sizeRight}
</div>

            <button style={cardBtn} onClick={()=>{
              setShowCardForm(false);
              pay("card",cardSide==="left"?currentLeft:currentRight,cardSide==="left"?sizeLeft:sizeRight,cardSide);
            }}>
              Continue
            </button>
          </div>
        </div>
      )}

      {/* CRYPTO POPUP */}
      {showCryptoForm && (
        <div style={overlay}>
          <div style={{ ...modalBox, maxWidth: 400 }}>
            <button onClick={() => setShowCryptoForm(false)} style={closeBtn}>&times;</button>

            <input placeholder="Name" value={shipping.name} onChange={(e)=>setShipping({...shipping,name:e.target.value})} style={inputStyle}/>
            <input placeholder="Email" value={shipping.email} onChange={(e)=>setShipping({...shipping,email:e.target.value})} style={inputStyle}/>
            <input placeholder="Address" value={shipping.address} onChange={(e)=>setShipping({...shipping,address:e.target.value})} style={inputStyle}/>
            <div style={{
  ...inputStyle,
  display: "flex",
  alignItems: "center",
  color: "#FFD700",
  fontWeight: "bold"
}}>
  {cryptoSide==="left"?sizeLeft:sizeRight}
</div>

            <div style={sizeRow}>
              {SIZES.map((s) => (
                <button key={s} onClick={()=>{
                  if (cryptoSide==="left") setSizeLeft(s);
                  else setSizeRight(s);
                }} style={sizeBtn}>
                  {s}
                </button>
              ))}
            </div>

            <button style={cardBtn} onClick={()=>{
              setShowCryptoForm(false);
              pay("crypto",cryptoSide==="left"?currentLeft:currentRight,cryptoSide==="left"?sizeLeft:sizeRight,cryptoSide);
            }}>
              Continue
            </button>
          </div>
        </div>
      )}

      {showTerms && (
        <div onClick={() => setShowTerms(false)} style={overlay}>
          <div onClick={(e) => e.stopPropagation()} style={{ ...modalBox, maxWidth: 500 }}>
            <button onClick={() => setShowTerms(false)} style={closeBtn}>
              &times;
            </button>

            <h2 style={heading}>Terms & Conditions</h2>

            <div style={termsBody}>
              <p><b>1.</b> All merch orders are final and non-refundable.</p>
              <p><b>2.</b> Delivery times may vary depending on location.</p>
              <p><b>3.</b> The printed map design highlights your country.</p>
              <p><b>4.</b> Payments are processed via Stripe or crypto.</p>
              <p><b>5.</b> Orders may be cancelled in case of fraud.</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}     
/* ================= STYLES ================= */

const overlay = {
  position: "fixed",
  inset: 0,
  zIndex: 200000,
  background: "rgba(0,0,0,0.88)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const modalBox = {
  position: "relative",
  background: "#0a0a0a",
  border: "1px solid #333",
  borderRadius: 14,

  width: "100%",
  maxWidth: 380,

  padding: "18px 14px 14px",
  maxHeight: "92vh",

  overflowY: "auto",

  flex: 1,
};

const closeBtn = {
  position: "absolute",
  top: 12,
  right: 16,
  background: "none",
  border: "none",
  color: "#999",
  fontSize: "1.6rem",
  cursor: "pointer",
};

const heading = {
  color: "#FFD700",
  fontFamily: "Cinzel, serif",
  fontSize: "1.4rem",
  marginBottom: 2,
  textAlign: "center",
};

const sub = {
  color: "#777",
  fontSize: "0.82rem",
  textAlign: "center",
  marginBottom: 18,
};

const productRow = {
  display: "flex",
  gap: 16,
  justifyContent: "center",
  marginBottom: 18,
};

const productCard = {
  flex: "1 1 0",
  maxWidth: "none",
  borderRadius: 10,
  background: "#111",
  padding: 10,
  cursor: "pointer",
  transition: "border 0.2s, box-shadow 0.2s",
  textAlign: "center",
};

const imageWrap = {
  position: "relative",
  width: "100%",
  aspectRatio: "1 / 1.3",
  overflow: "hidden",
  borderRadius: 8,
  background: "#000",
};

const productImg = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
  display: "block",
};

const mapOverlay = {
  position: "absolute",
  top: "36%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  pointerEvents: "none",
  opacity: 0.95,
};

const mapOverlayTshirt = {
  position: "absolute",
  top: "28%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  pointerEvents: "none",
  opacity: 0.95,
};

const mapOverlayTshirtRight = {
  position: "absolute",
  top: "28%", 
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  pointerEvents: "none",
  opacity: 0.95,
};

const productLabel = {
  color: "#fff",
  fontWeight: 700,
  fontSize: "0.95rem",
  marginTop: 8,
  letterSpacing: "0.06em",
};

const productPrice = {
  color: "#FFD700",
  fontWeight: 700,
  fontSize: "1.15rem",
  marginTop: 2,
};

const sizeRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 6,
  marginBottom: 14,
};

const sizeBtn = {
  padding: "5px 12px",
  borderRadius: 6,
  fontSize: "0.8rem",
  fontWeight: 700,
  cursor: "pointer",
  transition: "all 0.15s",
};

const termsRow = {
  textAlign: "center",
  marginBottom: 12,
};

const btnRow = {
  display: "flex",
  gap: 10,
};

const cardBtn = {
  flex: 1,
  background: "#FFD700",
  color: "#000",
  padding: "12px",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "0.95rem",
};

const cryptoBtn = {
  flex: 1,
  background: "#000",
  color: "#FFD700",
  padding: "12px",
  border: "2px solid #FFD700",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "0.95rem",
};

const termsBody = {
  color: "#ccc",
  fontSize: "0.82rem",
  lineHeight: 1.7,
  maxHeight: "60vh",
  overflowY: "auto",
  paddingRight: 6,
};
const inputStyle = {
  width: "100%",
  marginBottom: 8,
  padding: "10px",
  background: "#111",
  border: "1px solid #333",
  color: "#fff",
  borderRadius: 6
};
